var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Masks extends Component {
    constructor() {
        super('Masks', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            Masks.applyBottomMask();
            $(window).on(['resize', 'scroll'], () => {
                Masks.applyBottomMask();
            });
            this.success();
        });
    }
    static applyBottomMask() {
        if ($(window).width() < 768)
            return;
        $('.inventory-row').each((element) => {
            const y = element.viewportPosition().y;
            const gradientStart = $(window).height() - $(window).height() / 3;
            const gradientEnd = $(window).height() - $('menu').height() - 32;
            const opacity = Math.min(Math.max((y - gradientEnd) / (gradientStart - gradientEnd), 0), 1);
            element.css('opacity', opacity);
        });
    }
}
